import { Component, OnInit } from '@angular/core';
import { MessagesService } from './../../../shared/services/messages.service';
import { UsersService } from './../../../shared/services/users.service';
import { ActiveUserLocalDataService } from './../../../shared/services/active-user-local-data.service';
import { GetMessagesRequest, GetMessagesResponse, PostMessageAnswerRequest, GetMessagesModel } from './../../../shared/models/messages.models';
import { MessageNotificationService } from './../../../shared/services/message-notification.service';
import { CourierService } from '../../../shared/services/courier.service';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss']
})
export class MessagesComponent implements OnInit {

  messagesResponse: GetMessagesResponse | null = null;
  loading: boolean = true;
  unreadMessages: GetMessagesModel[] = [];
  readMessages: GetMessagesModel[] = [];

  constructor(
    private usersService: UsersService,
    private messagesService: MessagesService,
    private messageNotificationService: MessageNotificationService,
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private courierService: CourierService
  ) {}

  ngOnInit() {
    this.refreshActiveVoucher().then(() => {
      this.loadMessages();
    });
  }
  async refreshActiveVoucher() {
    // You may want to move this logic to a shared service if needed
    if (this.courierService) {
      const request = {};
      try {
        const response = await this.courierService.getActiveVouchers(request).toPromise();
        if (response && response.voucher) {
          this.activeUserLocalDataService.setActiveCourierVoucher(response.voucher);
        } else {
          this.activeUserLocalDataService.setActiveCourierVoucher(null);
        }
      } catch (error) {
        console.error('[refreshActiveVoucher] Error:', error);
      }
    } else {
      console.warn('[refreshActiveVoucher] courierService is not available!');
    }
  }

  loadMessages() {
    this.loading = true;
    // Retrieve the active voucher first
    const voucher = this.activeUserLocalDataService.getActiveCourierVoucher();
    const carId = voucher?.carsId ?? 0;
    this.usersService.getUserInfo().subscribe(user => {
      const userId = user.id;
      const requestParams = { userId, carId } as GetMessagesRequest;
      this.messagesService.getMessagesList(requestParams).subscribe(response => {
        this.messagesResponse = response;
        this.unreadMessages = response.messages.filter(x => !x.responsed);
        this.readMessages = response.messages.filter(x => x.responsed);
        this.loading = false;
        if (this.unreadMessages.length === 0) {
          this.messageNotificationService.notifyUnreadMessagesUpdated();
        }
      });
    }, error => {
      this.loading = false;
    });
  }

  truncateMessage(message: string | null, maxLength: number = 30): string {
    if (!message) return '';
    return message.length <= maxLength ? message : `${message.substring(0, maxLength)}...`;
  }

  postMessageAnswer(messageId: number, messageResponseId: number) {
  const voucher = this.activeUserLocalDataService.getActiveCourierVoucher();
  const carId = voucher?.carsId ?? 0;
  const request: PostMessageAnswerRequest = {
    messageId: messageId,
    messageResponseId: messageResponseId,
    carId: carId
  };
  this.messagesService.postMessageAnswer(request).subscribe(response => {
    if (response) {
      this.loadMessages();
      this.messageNotificationService.notifyUnreadMessagesUpdated();
    }
  });
}
}